export default __webpack_public_path__ + "static/media/Ellipse.34773148.png";